import client from './client';
import { PickupPreference, PickupSelection } from '../types';

export const getPickupPreference = async (
  storeId: string,
): Promise<PickupPreference | null> => {
  const { data } = await client.get(`pickup-preferences/${storeId}`);
  return data;
};

export const upsertPickupPreference = async (
  storeId: string,
  selection: PickupSelection,
): Promise<PickupPreference> => {
  const { data } = await client.put(`pickup-preferences/${storeId}`, selection);
  return data;
};
